import useHostGlobals from 'appHost/Globals';
import useUser from 'hooks/useUser';

export const useGlobals = () => {
  const hostGlobals = useHostGlobals();

  return {
    user: hostGlobals?.user || useUser(),
    history: hostGlobals?.history,
    amplitude: hostGlobals?.amplitude,
    featureToggles: hostGlobals?.featureToggles,
    features: hostGlobals?.features,
    planMigration: hostGlobals?.planMigration,
    foco: hostGlobals?.foco,
    isShowNewHorizontal: hostGlobals?.isShowNewHorizontal,
  };
};
